import axios from 'axios'
import AdicionarDocumentoPedidoInput from '@/core/apiclient/pedido/documentos/documento/editor-texto/models/AdicionarDocumentoPedidoInput'

const URL_PATH = 'api/pedido/documentos/documentos-editor'
class DocumentoEditorTextoApiClient {
	async adicionarDocumento(dados) {
		return axios.post(
			`${URL_PATH}`,
			new AdicionarDocumentoPedidoInput(
				dados.id,
				dados.titulo,
				dados.idTipoDocumento,
				dados.idModeloDocumento,
				dados.idPenalidade,
			),
		)
	}

	async buscarPorId(idDocumento) {
		return await axios.get(`api/pedido/documentos/${idDocumento}/editor-texto`)
	}

	async redigir(idDocumento) {
		return await axios.put(`${URL_PATH}/${idDocumento}`)
	}
	async visualizar(idDocumento) {
		return await axios.get(`${URL_PATH}/${idDocumento}`)
	}

	async sincronizar(idDocumento) {
		return await axios.put(`${URL_PATH}/${idDocumento}/sincronizar`)
	}
}

export default new DocumentoEditorTextoApiClient()
